import { Map } from 'immutable'
import { isAfter } from 'date-fns'

import tokenize from './tokenize'

const search = (consultants, term) =>
  consultants
    .map(consultant => {
      if (
        (consultant.titles || []).includes(term) ||
        (consultant.experience || []).some(
          experience =>
            (experience.type === 'work' &&
              (experience.roles || []).includes(term)) ||
            experience.employer === term ||
            experience.customer === term ||
            (experience.type === 'work' &&
              (experience.tags || []).includes(term))
        )
      ) {
        return {
          id: consultant.id,
          matches: [
            {
              term,
              type: 'work',
            },
          ],
        }
      } else if ((consultant.interests || []).includes(term)) {
        return {
          id: consultant.id,
          matches: [
            {
              term,
              type: 'interest',
            },
          ],
        }
      } else if (
        (consultant.experience || []).some(
          experience =>
            experience.degree === term ||
            experience.university === term ||
            (experience.type === 'education' &&
              (experience.description || '').includes(term))
        )
      ) {
        return {
          id: consultant.id,
          matches: [
            {
              term,
              type: 'education',
            },
          ],
        }
      } else if (
        (consultant.experience || []).some(experience =>
          (experience.tags || []).includes(term)
        )
      ) {
        return {
          id: consultant.id,
          matches: [
            {
              term,
              type: 'hobby',
            },
          ],
        }
      } else if (
        (consultant.experience || []).some(experience =>
          (experience.roles || []).includes(term)
        )
      ) {
        return {
          id: consultant.id,
          matches: [
            {
              term,
              type: 'hobby',
            },
          ],
        }
      } else if (
        (consultant.name || '').toLowerCase().includes(term.toLowerCase()) ||
        (consultant.experience || []).some(experience =>
          (experience.description || '').includes(term)
        )
      ) {
        return {
          id: consultant.id,
          matches: [
            {
              term,
            },
          ],
        }
      }
      return undefined
    })
    .filter(c => c)

const availabilitySort = consultants => (idA, idB) => {
  const a = consultants[idA]
  const b = consultants[idB]
  if (a && b && a.availability && b.availability) {
    switch (a.availability.type) {
      case 'date': {
        switch (b.availability.type) {
          case 'date':
            return isAfter(a.availability.date, b.availability.date) ? 1 : -1
          case 'now':
            return 1
          case 'unavailable':
            return -1
          case 'other':
            return -1
          default:
            return 0
        }
      }
      case 'now':
        return -1
      case 'unavailable':
        return 1
      case 'other':
        switch (b.availability.type) {
          case 'date':
            return 1
          case 'now':
            return 1
          case 'unavailable':
            return -1
          case 'other':
            return 0
          default:
            return 0
        }
      default:
        return 0
    }
  } else if (a && a.availability) {
    return a.availability.type === 'unavailable' ? 1 : -1
  } else if (b && b.availability) {
    return b.availability.type === 'unavailable' ? -1 : 1
  } else {
    return 0
  }
}

export default ({ query = '', consultants = {}, tags = [] }) => {
  const availableConsultantIds = Object.keys(consultants).sort(
    availabilitySort(consultants)
  )

  if (!query) return availableConsultantIds.map(id => ({ id }))

  const list = availableConsultantIds.map(id => ({
    ...consultants[id],
    id,
  }))

  return tokenize(query, tags.map(tag => tag.name))
    .map(term => ({
      result: search(list, term),
      term,
    }))
    .reduce(
      (results, { term, result }) =>
        result.reduce(
          (prev, curr) =>
            prev.update(curr.id, { matches: [] }, value => ({
              id: curr.id,
              matches: [...value.matches, ...curr.matches],
            })),
          results
        ),
      new Map()
    )
    .valueSeq()
    .sort((a, b) => {
      const diff = b.matches.length - a.matches.length
      if (diff === 0) {
        return (
          a.matches
            .map(({ type }) => typeRank.indexOf(type))
            .reduce((sum, index) => sum + index, 0) -
          b.matches
            .map(({ type }) => typeRank.indexOf(type))
            .reduce((sum, index) => sum + index, 0)
        )
      }
      return diff
    })
    .sort((a, b) => availabilitySort(consultants)(a.id, b.id))
    .toJS()
}

const typeRank = ['work', 'interest', 'education', 'hobby', undefined]



// WEBPACK FOOTER //
// ./src/utils/search.js